var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnbelievablePain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2640_1292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.2998,
    cy: 22,
    r: 20,
    fill: "#EC5255"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.2998,
    cy: 22,
    r: 19,
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1209 21.6219C34.0756 20.7386 33.083 19.9935 33.0731 19.9861C33.037 19.9591 32.9944 19.9422 32.9496 19.9371C32.9048 19.9321 32.8594 19.9391 32.8183 19.9575C32.7771 19.9758 32.7416 20.0048 32.7154 20.0415C32.6892 20.0782 32.6732 20.1212 32.6692 20.1661C32.6681 20.1785 32.5587 21.4147 32.5169 22.7827C32.4599 24.6477 32.5521 25.8652 32.7911 26.4013C33.3856 27.7351 34.9544 28.3365 36.2881 27.742C37.6219 27.1475 38.2233 25.5787 37.6288 24.245C37.3898 23.7088 36.546 22.8263 35.1209 21.6219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9084 21.6219C12.9537 20.7386 13.9463 19.9935 13.9562 19.9861C13.9923 19.9591 14.0349 19.9422 14.0797 19.9371C14.1245 19.9321 14.1698 19.9391 14.211 19.9575C14.2522 19.9758 14.2877 20.0048 14.3139 20.0415C14.3401 20.0782 14.3561 20.1212 14.3601 20.1661C14.3612 20.1785 14.4706 21.4147 14.5124 22.7827C14.5694 24.6477 14.4772 25.8652 14.2382 26.4013C13.6437 27.7351 12.0749 28.3365 10.7412 27.742C9.4074 27.1475 8.80597 25.5787 9.40048 24.245C9.63946 23.7088 10.4832 22.8263 11.9084 21.6219Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1982 14L19.6982 17L14.1982 19.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4014 14L26.9014 17L32.4014 19.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1765 22.2172C21.0221 21.4622 22.0734 20.9999 23.2021 20.9999C24.3309 20.9999 25.3821 21.4622 26.2278 22.2172C27.4221 23.2827 28.2021 24.9372 28.2021 26.5555C28.2021 29.3588 25.9615 30.9999 23.2021 30.9999C20.4428 30.9999 18.2021 29.3588 18.2021 26.5555C18.2021 24.9372 18.9821 23.2827 20.1765 22.2172Z",
    fill: "#333333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2640_1292",
    x: 0.299805,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2640_1292"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2640_1292",
    result: "effect2_dropShadow_2640_1292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2640_1292",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnbelievablePain);
export default __webpack_public_path__ + "static/media/ic-unbelievable-pain.a6de32a8be9a746ed219121b1487e6c6.svg";
export { ForwardRef as ReactComponent };